import developersService from "./developers.service";

async function onboard({ name, email, company }) {
  return developersService.onboard({ name, email, company });
}

async function getProfile() {
  return developersService.getMe();
}

async function updateProfile(fields) {
  return developersService.updateMe(fields);
}

async function regenerateKey() {
  return developersService.regenerateKey();
}

async function getUsage() {
  return developersService.getUsage();
}

async function deleteAccount() {
  return developersService.deleteMe();
}

async function uploadAvatar(imageData) {
  return developersService.uploadAvatar(imageData);
}

const developerService = {
  onboard,
  getProfile,
  updateProfile,
  regenerateKey,
  getUsage,
  deleteAccount,
  uploadAvatar,
};

export default developerService;
